import { render, staticRenderFns } from "./MemberTalkDetailSetting.vue?vue&type=template&id=ca6c7af0&scoped=true&"
import script from "./MemberTalkDetailSetting.vue?vue&type=script&lang=js&"
export * from "./MemberTalkDetailSetting.vue?vue&type=script&lang=js&"
import style0 from "./MemberTalkDetailSetting.vue?vue&type=style&index=0&id=ca6c7af0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6c7af0",
  null
  
)

export default component.exports